export const eclipseTheme = {
  eclipseTier1: {
    color: {
      transparency: {
        '0': 'var(--eclipse-tier1-color-transparency-0)',
        balticSea: {
          '70-30': 'var(--eclipse-tier1-color-transparency-baltic-sea-7030)',
          '80-50': 'var(--eclipse-tier1-color-transparency-baltic-sea-8050)',
          '100-50': 'var(--eclipse-tier1-color-transparency-baltic-sea-10050)',
          '110-10': 'var(--eclipse-tier1-color-transparency-baltic-sea-11010)',
          '110-50': 'var(--eclipse-tier1-color-transparency-baltic-sea-11050)',
          '110-70': 'var(--eclipse-tier1-color-transparency-baltic-sea-11070)',
        },
      },
      seaweed: {
        '10': 'var(--eclipse-tier1-color-seaweed-10)',
        '20': 'var(--eclipse-tier1-color-seaweed-20)',
        '30': 'var(--eclipse-tier1-color-seaweed-30)',
        '40': 'var(--eclipse-tier1-color-seaweed-40)',
        '50': 'var(--eclipse-tier1-color-seaweed-50)',
      },
      infoBlue: {
        '10': 'var(--eclipse-tier1-color-info-blue-10)',
        '20': 'var(--eclipse-tier1-color-info-blue-20)',
        '30': 'var(--eclipse-tier1-color-info-blue-30)',
        '40': 'var(--eclipse-tier1-color-info-blue-40)',
        '50': 'var(--eclipse-tier1-color-info-blue-50)',
      },
      mango: {
        '10': 'var(--eclipse-tier1-color-mango-10)',
        '20': 'var(--eclipse-tier1-color-mango-20)',
        '30': 'var(--eclipse-tier1-color-mango-30)',
        '40': 'var(--eclipse-tier1-color-mango-40)',
        '50': 'var(--eclipse-tier1-color-mango-50)',
      },
      focusBlue: {
        '10': 'var(--eclipse-tier1-color-focus-blue-10)',
        '20': 'var(--eclipse-tier1-color-focus-blue-20)',
      },
      chili: {
        '10': 'var(--eclipse-tier1-color-chili-10)',
        '20': 'var(--eclipse-tier1-color-chili-20)',
        '30': 'var(--eclipse-tier1-color-chili-30)',
        '40': 'var(--eclipse-tier1-color-chili-40)',
        '50': 'var(--eclipse-tier1-color-chili-50)',
      },
      balticSea: {
        '10': 'var(--eclipse-tier1-color-baltic-sea-10)',
        '20': 'var(--eclipse-tier1-color-baltic-sea-20)',
        '30': 'var(--eclipse-tier1-color-baltic-sea-30)',
        '40': 'var(--eclipse-tier1-color-baltic-sea-40)',
        '50': 'var(--eclipse-tier1-color-baltic-sea-50)',
        '60': 'var(--eclipse-tier1-color-baltic-sea-60)',
        '70': 'var(--eclipse-tier1-color-baltic-sea-70)',
        '80': 'var(--eclipse-tier1-color-baltic-sea-80)',
        '90': 'var(--eclipse-tier1-color-baltic-sea-90)',
        '100': 'var(--eclipse-tier1-color-baltic-sea-100)',
        '110': 'var(--eclipse-tier1-color-baltic-sea-110)',
      },
      indigo: {
        '10': 'var(--eclipse-tier1-color-indigo-10)',
        '20': 'var(--eclipse-tier1-color-indigo-20)',
        '30': 'var(--eclipse-tier1-color-indigo-30)',
        '40': 'var(--eclipse-tier1-color-indigo-40)',
        '50': 'var(--eclipse-tier1-color-indigo-50)',
        '60': 'var(--eclipse-tier1-color-indigo-60)',
        '70': 'var(--eclipse-tier1-color-indigo-70)',
        '80': 'var(--eclipse-tier1-color-indigo-80)',
        '90': 'var(--eclipse-tier1-color-indigo-90)',
        '100': 'var(--eclipse-tier1-color-indigo-100)',
      },
      white: 'var(--eclipse-tier1-color-white)',
      black: 'var(--eclipse-tier1-color-black)',
    },
    typography: {
      fontSize: {
        '12': 'var(--eclipse-tier1-typography-font-size-12)',
        '14': 'var(--eclipse-tier1-typography-font-size-14)',
        '16': 'var(--eclipse-tier1-typography-font-size-16)',
        '24': 'var(--eclipse-tier1-typography-font-size-24)',
        '32': 'var(--eclipse-tier1-typography-font-size-32)',
        '44': 'var(--eclipse-tier1-typography-font-size-44)',
      },
      fontWeight: {
        semibold: 'var(--eclipse-tier1-typography-font-weight-semibold)',
        medium: 'var(--eclipse-tier1-typography-font-weight-medium)',
        regular: 'var(--eclipse-tier1-typography-font-weight-regular)',
      },
      fontFamily: {
        inter: 'var(--eclipse-tier1-typography-font-family-inter)',
      },
      lineHeight: {
        '16': 'var(--eclipse-tier1-typography-line-height-16)',
        '20': 'var(--eclipse-tier1-typography-line-height-20)',
        '24': 'var(--eclipse-tier1-typography-line-height-24)',
        '32': 'var(--eclipse-tier1-typography-line-height-32)',
        '40': 'var(--eclipse-tier1-typography-line-height-40)',
        '52': 'var(--eclipse-tier1-typography-line-height-52)',
      },
    },
    radius: {
      '9999px': 'var(--eclipse-tier1-radius-9999px)',
      '16px': 'var(--eclipse-tier1-radius-16px)',
      '20px': 'var(--eclipse-tier1-radius-20px)',
      '8px': 'var(--eclipse-tier1-radius-8px)',
      '4px': 'var(--eclipse-tier1-radius-4px)',
      '12px': 'var(--eclipse-tier1-radius-12px)',
      '2px': 'var(--eclipse-tier1-radius-2px)',
      '0px': 'var(--eclipse-tier1-radius-0px)',
    },
    sizing: {
      '112px': 'var(--eclipse-tier1-sizing-112px)',
      '80px': 'var(--eclipse-tier1-sizing-80px)',
      '64px': 'var(--eclipse-tier1-sizing-64px)',
      '48px': 'var(--eclipse-tier1-sizing-48px)',
      '16px': 'var(--eclipse-tier1-sizing-16px)',
      '36px': 'var(--eclipse-tier1-sizing-36px)',
      '20px': 'var(--eclipse-tier1-sizing-20px)',
      '40px': 'var(--eclipse-tier1-sizing-40px)',
      '24px': 'var(--eclipse-tier1-sizing-24px)',
    },
    breakpoints: {
      width: {
        max: {
          xl: 1920,
          lg: 1439,
          sm: 767,
          xs: 575,
          md: 1023,
        },
        min: {
          md: 768,
          xl: 1440,
          xs: 0,
          lg: 1024,
          sm: 576,
        },
      },
    },
    spacing: {
      '24px': 'var(--eclipse-tier1-spacing-24px)',
      '32px': 'var(--eclipse-tier1-spacing-32px)',
      '40px': 'var(--eclipse-tier1-spacing-40px)',
      '2px': 'var(--eclipse-tier1-spacing-2px)',
      '16px': 'var(--eclipse-tier1-spacing-16px)',
      '12px': 'var(--eclipse-tier1-spacing-12px)',
      '8px': 'var(--eclipse-tier1-spacing-8px)',
      '4px': 'var(--eclipse-tier1-spacing-4px)',
      '64px': 'var(--eclipse-tier1-spacing-64px)',
      '20px': 'var(--eclipse-tier1-spacing-20px)',
      '0px': 'var(--eclipse-tier1-spacing-0px)',
      '48px': 'var(--eclipse-tier1-spacing-48px)',
    },
  },
  eclipseTier2Typography: {
    title: {
      lineHeight: 'var(--eclipse-tier2-typography-title-line-height)',
      fontSize: 'var(--eclipse-tier2-typography-title-font-size)',
      fontFamily: 'var(--eclipse-tier2-typography-title-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-title-font-weight)',
    },
    link: {
      lineHeight: 'var(--eclipse-tier2-typography-link-line-height)',
      fontFamily: 'var(--eclipse-tier2-typography-link-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-link-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-link-font-size)',
    },
    labelMdSemibold: {
      fontWeight: 'var(--eclipse-tier2-typography-label-md-semibold-font-weight)',
      fontFamily: 'var(--eclipse-tier2-typography-label-md-semibold-font-family)',
      lineHeight: 'var(--eclipse-tier2-typography-label-md-semibold-line-height)',
      fontSize: 'var(--eclipse-tier2-typography-label-md-semibold-font-size)',
    },
    labelSmSemibold: {
      fontSize: 'var(--eclipse-tier2-typography-label-sm-semibold-font-size)',
      lineHeight: 'var(--eclipse-tier2-typography-label-sm-semibold-line-height)',
      fontFamily: 'var(--eclipse-tier2-typography-label-sm-semibold-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-label-sm-semibold-font-weight)',
    },
    bodySm: {
      lineHeight: 'var(--eclipse-tier2-typography-body-sm-line-height)',
      fontFamily: 'var(--eclipse-tier2-typography-body-sm-font-family)',
      fontSize: 'var(--eclipse-tier2-typography-body-sm-font-size)',
      fontWeight: 'var(--eclipse-tier2-typography-body-sm-font-weight)',
    },
    bodyMd: {
      lineHeight: 'var(--eclipse-tier2-typography-body-md-line-height)',
      fontSize: 'var(--eclipse-tier2-typography-body-md-font-size)',
      fontWeight: 'var(--eclipse-tier2-typography-body-md-font-weight)',
      fontFamily: 'var(--eclipse-tier2-typography-body-md-font-family)',
    },
    headingMdSemibold: {
      fontFamily: 'var(--eclipse-tier2-typography-heading-md-semibold-font-family)',
      lineHeight: 'var(--eclipse-tier2-typography-heading-md-semibold-line-height)',
      fontSize: 'var(--eclipse-tier2-typography-heading-md-semibold-font-size)',
      fontWeight: 'var(--eclipse-tier2-typography-heading-md-semibold-font-weight)',
    },
    headingMd: {
      fontWeight: 'var(--eclipse-tier2-typography-heading-md-font-weight)',
      lineHeight: 'var(--eclipse-tier2-typography-heading-md-line-height)',
      fontSize: 'var(--eclipse-tier2-typography-heading-md-font-size)',
      fontFamily: 'var(--eclipse-tier2-typography-heading-md-font-family)',
    },
    navHeader: {
      lineHeight: 'var(--eclipse-tier2-typography-nav-header-line-height)',
      fontSize: 'var(--eclipse-tier2-typography-nav-header-font-size)',
      fontFamily: 'var(--eclipse-tier2-typography-nav-header-font-family)',
      fontWeight: 'var(--eclipse-tier2-typography-nav-header-font-weight)',
    },
    display: {
      lineHeight: 'var(--eclipse-tier2-typography-display-line-height)',
      fontSize: 'var(--eclipse-tier2-typography-display-font-size)',
      fontWeight: 'var(--eclipse-tier2-typography-display-font-weight)',
      fontFamily: 'var(--eclipse-tier2-typography-display-font-family)',
    },
    labelMd: {
      fontFamily: 'var(--eclipse-tier2-typography-label-md-font-family)',
      lineHeight: 'var(--eclipse-tier2-typography-label-md-line-height)',
      fontWeight: 'var(--eclipse-tier2-typography-label-md-font-weight)',
      fontSize: 'var(--eclipse-tier2-typography-label-md-font-size)',
    },
    headingLg: {
      fontFamily: 'var(--eclipse-tier2-typography-heading-lg-font-family)',
      lineHeight: 'var(--eclipse-tier2-typography-heading-lg-line-height)',
      fontSize: 'var(--eclipse-tier2-typography-heading-lg-font-size)',
      fontWeight: 'var(--eclipse-tier2-typography-heading-lg-font-weight)',
    },
  },
  eclipseTier2Color: {
    background: {
      success: {
        bold: {
          hovered: 'var(--eclipse-tier2-color-background-success-bold-hovered)',
          default: 'var(--eclipse-tier2-color-background-success-bold-default)',
          pressed: 'var(--eclipse-tier2-color-background-success-bold-pressed)',
        },
        subtle: 'var(--eclipse-tier2-color-background-success-subtle)',
      },
      info: {
        subtle: 'var(--eclipse-tier2-color-background-info-subtle)',
        bold: {
          pressed: 'var(--eclipse-tier2-color-background-info-bold-pressed)',
          hovered: 'var(--eclipse-tier2-color-background-info-bold-hovered)',
          default: 'var(--eclipse-tier2-color-background-info-bold-default)',
        },
      },
      input: 'var(--eclipse-tier2-color-background-input)',
      disabled: {
        subtle: 'var(--eclipse-tier2-color-background-disabled-subtle)',
        default: 'var(--eclipse-tier2-color-background-disabled-default)',
      },
      neutral: {
        bold: 'var(--eclipse-tier2-color-background-neutral-bold)',
        subtle: {
          hovered: 'var(--eclipse-tier2-color-background-neutral-subtle-hovered)',
          selected: 'var(--eclipse-tier2-color-background-neutral-subtle-selected)',
          default: 'var(--eclipse-tier2-color-background-neutral-subtle-default)',
        },
        subtlest: {
          selected: 'var(--eclipse-tier2-color-background-neutral-subtlest-selected)',
          hovered: 'var(--eclipse-tier2-color-background-neutral-subtlest-hovered)',
          default: 'var(--eclipse-tier2-color-background-neutral-subtlest-default)',
        },
      },
      nav: {
        selected: 'var(--eclipse-tier2-color-background-nav-selected)',
        hovered: 'var(--eclipse-tier2-color-background-nav-hovered)',
        default: 'var(--eclipse-tier2-color-background-nav-default)',
      },
      brand: {
        bold: {
          pressed: 'var(--eclipse-tier2-color-background-brand-bold-pressed)',
          hovered: 'var(--eclipse-tier2-color-background-brand-bold-hovered)',
          default: 'var(--eclipse-tier2-color-background-brand-bold-default)',
        },
        subtle: {
          hovered: 'var(--eclipse-tier2-color-background-brand-subtle-hovered)',
          pressed: 'var(--eclipse-tier2-color-background-brand-subtle-pressed)',
          default: 'var(--eclipse-tier2-color-background-brand-subtle-default)',
        },
      },
      error: {
        subtle: 'var(--eclipse-tier2-color-background-error-subtle)',
        bold: {
          hovered: 'var(--eclipse-tier2-color-background-error-bold-hovered)',
          default: 'var(--eclipse-tier2-color-background-error-bold-default)',
          pressed: 'var(--eclipse-tier2-color-background-error-bold-pressed)',
        },
      },
      warning: {
        subtle: 'var(--eclipse-tier2-color-background-warning-subtle)',
        bold: {
          pressed: 'var(--eclipse-tier2-color-background-warning-bold-pressed)',
          hovered: 'var(--eclipse-tier2-color-background-warning-bold-hovered)',
          default: 'var(--eclipse-tier2-color-background-warning-bold-default)',
        },
      },
    },
    text: {
      subtle: 'var(--eclipse-tier2-color-text-subtle)',
      disabled: 'var(--eclipse-tier2-color-text-disabled)',
      selected: 'var(--eclipse-tier2-color-text-selected)',
      warningInverse: 'var(--eclipse-tier2-color-text-warning-inverse)',
      inverse: 'var(--eclipse-tier2-color-text-inverse)',
      subtlest: 'var(--eclipse-tier2-color-text-subtlest)',
      brand: {
        default: 'var(--eclipse-tier2-color-text-brand-default)',
        visited: 'var(--eclipse-tier2-color-text-brand-visited)',
        pressed: 'var(--eclipse-tier2-color-text-brand-pressed)',
        hovered: 'var(--eclipse-tier2-color-text-brand-hovered)',
      },
      error: {
        onSubtle: 'var(--eclipse-tier2-color-text-error-on-subtle)',
        default: 'var(--eclipse-tier2-color-text-error-default)',
      },
      warning: {
        onSubtle: 'var(--eclipse-tier2-color-text-warning-on-subtle)',
        default: 'var(--eclipse-tier2-color-text-warning-default)',
      },
      success: {
        onSubtle: 'var(--eclipse-tier2-color-text-success-on-subtle)',
        default: 'var(--eclipse-tier2-color-text-success-default)',
      },
      info: {
        onSubtle: 'var(--eclipse-tier2-color-text-info-on-subtle)',
        default: 'var(--eclipse-tier2-color-text-info-default)',
      },
      default: 'var(--eclipse-tier2-color-text-default)',
    },
    border: {
      warning: 'var(--eclipse-tier2-color-border-warning)',
      error: 'var(--eclipse-tier2-color-border-error)',
      input: 'var(--eclipse-tier2-color-border-input)',
      info: 'var(--eclipse-tier2-color-border-info)',
      focus: 'var(--eclipse-tier2-color-border-focus)',
      subtle: 'var(--eclipse-tier2-color-border-subtle)',
      success: 'var(--eclipse-tier2-color-border-success)',
      disabled: 'var(--eclipse-tier2-color-border-disabled)',
      selected: 'var(--eclipse-tier2-color-border-selected)',
      bold: 'var(--eclipse-tier2-color-border-bold)',
      nav: {
        subtle: 'var(--eclipse-tier2-color-border-nav-subtle)',
        bold: 'var(--eclipse-tier2-color-border-nav-bold)',
      },
      brand: {
        pressed: 'var(--eclipse-tier2-color-border-brand-pressed)',
        hovered: 'var(--eclipse-tier2-color-border-brand-hovered)',
        default: 'var(--eclipse-tier2-color-border-brand-default)',
      },
    },
    surface: {
      structure: 'var(--eclipse-tier2-color-surface-structure)',
      raised: 'var(--eclipse-tier2-color-surface-raised)',
      sunken: 'var(--eclipse-tier2-color-surface-sunken)',
      elevation: {
        shadow: 'var(--eclipse-tier2-color-surface-elevation-shadow)',
        blanket: 'var(--eclipse-tier2-color-surface-elevation-blanket)',
      },
    },
    skeleton: {
      shimmer: 'var(--eclipse-tier2-color-skeleton-shimmer)',
      default: 'var(--eclipse-tier2-color-skeleton-default)',
    },
    elevation: {
      shadow: {
        level1: {
          key: {
            x: 'var(--eclipse-tier2-color-elevation-shadow-level1-key-x)',
            y: 'var(--eclipse-tier2-color-elevation-shadow-level1-key-y)',
            blur: 'var(--eclipse-tier2-color-elevation-shadow-level1-key-blur)',
            color: 'var(--eclipse-tier2-color-elevation-shadow-level1-key-color)',
          },
          ambient: {
            x: 'var(--eclipse-tier2-color-elevation-shadow-level1-ambient-x)',
            y: 'var(--eclipse-tier2-color-elevation-shadow-level1-ambient-y)',
            blur: 'var(--eclipse-tier2-color-elevation-shadow-level1-ambient-blur)',
            color: 'var(--eclipse-tier2-color-elevation-shadow-level1-ambient-color)',
          },
          boxShadow:
            'var(--eclipse-tier2-color-elevation-shadow-level1-key-x) var(--eclipse-tier2-color-elevation-shadow-level1-key-y) var(--eclipse-tier2-color-elevation-shadow-level1-key-blur) var(--eclipse-tier2-color-elevation-shadow-level1-key-color), var(--eclipse-tier2-color-elevation-shadow-level1-ambient-x) var(--eclipse-tier2-color-elevation-shadow-level1-ambient-y) var(--eclipse-tier2-color-elevation-shadow-level1-ambient-blur) var(--eclipse-tier2-color-elevation-shadow-level1-ambient-color)',
          dropShadow:
            'drop-shadow(var(--eclipse-tier2-color-elevation-shadow-level1-key-x) var(--eclipse-tier2-color-elevation-shadow-level1-key-y) var(--eclipse-tier2-color-elevation-shadow-level1-key-blur) var(--eclipse-tier2-color-elevation-shadow-level1-key-color)) drop-shadow(var(--eclipse-tier2-color-elevation-shadow-level1-ambient-x) var(--eclipse-tier2-color-elevation-shadow-level1-ambient-y) var(--eclipse-tier2-color-elevation-shadow-level1-ambient-blur) var(--eclipse-tier2-color-elevation-shadow-level1-ambient-color))',
        },
        level2: {
          key: {
            x: 'var(--eclipse-tier2-color-elevation-shadow-level2-key-x)',
            y: 'var(--eclipse-tier2-color-elevation-shadow-level2-key-y)',
            blur: 'var(--eclipse-tier2-color-elevation-shadow-level2-key-blur)',
            color: 'var(--eclipse-tier2-color-elevation-shadow-level2-key-color)',
          },
          ambient: {
            x: 'var(--eclipse-tier2-color-elevation-shadow-level2-ambient-x)',
            y: 'var(--eclipse-tier2-color-elevation-shadow-level2-ambient-y)',
            blur: 'var(--eclipse-tier2-color-elevation-shadow-level2-ambient-blur)',
            color: 'var(--eclipse-tier2-color-elevation-shadow-level2-ambient-color)',
          },
          boxShadow:
            'var(--eclipse-tier2-color-elevation-shadow-level2-key-x) var(--eclipse-tier2-color-elevation-shadow-level2-key-y) var(--eclipse-tier2-color-elevation-shadow-level2-key-blur) var(--eclipse-tier2-color-elevation-shadow-level2-key-color), var(--eclipse-tier2-color-elevation-shadow-level2-ambient-x) var(--eclipse-tier2-color-elevation-shadow-level2-ambient-y) var(--eclipse-tier2-color-elevation-shadow-level2-ambient-blur) var(--eclipse-tier2-color-elevation-shadow-level2-ambient-color)',
          dropShadow:
            'drop-shadow(var(--eclipse-tier2-color-elevation-shadow-level2-key-x) var(--eclipse-tier2-color-elevation-shadow-level2-key-y) var(--eclipse-tier2-color-elevation-shadow-level2-key-blur) var(--eclipse-tier2-color-elevation-shadow-level2-key-color)) drop-shadow(var(--eclipse-tier2-color-elevation-shadow-level2-ambient-x) var(--eclipse-tier2-color-elevation-shadow-level2-ambient-y) var(--eclipse-tier2-color-elevation-shadow-level2-ambient-blur) var(--eclipse-tier2-color-elevation-shadow-level2-ambient-color))',
        },
        level3: {
          key: {
            x: 'var(--eclipse-tier2-color-elevation-shadow-level3-key-x)',
            y: 'var(--eclipse-tier2-color-elevation-shadow-level3-key-y)',
            blur: 'var(--eclipse-tier2-color-elevation-shadow-level3-key-blur)',
            color: 'var(--eclipse-tier2-color-elevation-shadow-level3-key-color)',
          },
          ambient: {
            x: 'var(--eclipse-tier2-color-elevation-shadow-level3-ambient-x)',
            y: 'var(--eclipse-tier2-color-elevation-shadow-level3-ambient-y)',
            blur: 'var(--eclipse-tier2-color-elevation-shadow-level3-ambient-blur)',
            color: 'var(--eclipse-tier2-color-elevation-shadow-level3-ambient-color)',
          },
          boxShadow:
            'var(--eclipse-tier2-color-elevation-shadow-level3-key-x) var(--eclipse-tier2-color-elevation-shadow-level3-key-y) var(--eclipse-tier2-color-elevation-shadow-level3-key-blur) var(--eclipse-tier2-color-elevation-shadow-level3-key-color), var(--eclipse-tier2-color-elevation-shadow-level3-ambient-x) var(--eclipse-tier2-color-elevation-shadow-level3-ambient-y) var(--eclipse-tier2-color-elevation-shadow-level3-ambient-blur) var(--eclipse-tier2-color-elevation-shadow-level3-ambient-color)',
          dropShadow:
            'drop-shadow(var(--eclipse-tier2-color-elevation-shadow-level3-key-x) var(--eclipse-tier2-color-elevation-shadow-level3-key-y) var(--eclipse-tier2-color-elevation-shadow-level3-key-blur) var(--eclipse-tier2-color-elevation-shadow-level3-key-color)) drop-shadow(var(--eclipse-tier2-color-elevation-shadow-level3-ambient-x) var(--eclipse-tier2-color-elevation-shadow-level3-ambient-y) var(--eclipse-tier2-color-elevation-shadow-level3-ambient-blur) var(--eclipse-tier2-color-elevation-shadow-level3-ambient-color))',
        },
        overflow: {
          key: {
            x: 'var(--eclipse-tier2-color-elevation-shadow-overflow-key-x)',
            y: 'var(--eclipse-tier2-color-elevation-shadow-overflow-key-y)',
            blur: 'var(--eclipse-tier2-color-elevation-shadow-overflow-key-blur)',
            color: 'var(--eclipse-tier2-color-elevation-shadow-overflow-key-color)',
          },
          ambient: {
            x: 'var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-x)',
            y: 'var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-y)',
            blur: 'var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-blur)',
            color: 'var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-color)',
          },
          boxShadow:
            'var(--eclipse-tier2-color-elevation-shadow-overflow-key-x) var(--eclipse-tier2-color-elevation-shadow-overflow-key-y) var(--eclipse-tier2-color-elevation-shadow-overflow-key-blur) var(--eclipse-tier2-color-elevation-shadow-overflow-key-color), var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-x) var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-y) var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-blur) var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-color)',
          dropShadow:
            'drop-shadow(var(--eclipse-tier2-color-elevation-shadow-overflow-key-x) var(--eclipse-tier2-color-elevation-shadow-overflow-key-y) var(--eclipse-tier2-color-elevation-shadow-overflow-key-blur) var(--eclipse-tier2-color-elevation-shadow-overflow-key-color)) drop-shadow(var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-x) var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-y) var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-blur) var(--eclipse-tier2-color-elevation-shadow-overflow-ambient-color))',
        },
      },
      blanket: 'var(--eclipse-tier2-color-elevation-blanket)',
    },
  },
  eclipseResponsive: {
    columns: 'var(--eclipse-responsive-columns)',
    margin: 'var(--eclipse-responsive-margin)',
    gutter: 'var(--eclipse-responsive-gutter)',
  },
};
